export default function AuthLoading() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="flex flex-col items-center gap-4">
        <span className="loading loading-ring loading-xl"></span>
        <div className="text-lg font-light text-center">Authenticating</div>
      </div>
    </div>
  );
}
